<template>
  <create-dialog
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
    width="58%"
  >
    <template slot="form">
      <form>
        <div class="row">
          <div class="col-12 col-md-4">
            <fg-input
              type="text"
              :label="`${$t('common_words.code')}: *`"
              v-model="model.code"
              v-validate="modelValidations.code"
              name="common_words.code"
              :error="getError('common_words.code', true)"
              :disabled="disabledField"
              @click="handleClickOnCode()"
            >
            </fg-input>
          </div>
          <div class="col-12 col-md-4">
            <fg-input
              type="text"
              :label="`${$t('common_words.name')}: *`"
              v-model="model.name"
              v-validate="modelValidations.name"
              name="common_words.name"
              :error="getError('common_words.name', true)"
            >
            </fg-input>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <label class="text-transform-none"
            >{{ $t('common_words.modules') }}:</label
          >
          <el-select
            collapse-tags
            @change="selectAllFromSelect('model.module_id', modules)"
            clearable
            multiple
            class="select-primary custom-width-select bus-rels shadow-sm required-modules"
            v-model="model.module_id"
            filterable
            :placeholder="$t('common_words.select_one_or_many_modules2')"
          >
            <el-option
              v-for="option in modules"
              class="select-primary selected-all"
              :value="option.id"
              :label="`${option.id} - 
                ${translateDataBaseText(option.name, option.other_value)}`"
              :key="`${option.id} - ${option.name}`"
            ></el-option>
          </el-select>
        </div>
        <div class="col-12 col-md-4">
          <fg-input
            type="number"
            :label="`${$t('common_words.order_request')}: `"
            v-model="model.order"
            v-validate="modelValidations.order"
          >
          </fg-input>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <label>{{ $t('common_words.color') }}:</label>
            <sketch-picker
              :value="colors"
              @input="updateValue"
              v-if="renderComponent"
            ></sketch-picker>
          </div>
          <div class="col-4">
            <div class="form-group has-label">
              <label>{{ $t('common_words.text_color') }}:</label>
              <sketch-picker
                :value="colorst"
                @input="updateValueT"
              ></sketch-picker>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-8">
            <div class="form-group has-label">
              <label>{{ $t('common_words.description') }}:</label>
              <br />
              <el-input
                maxlength="300"
                show-word-limit
                class="shadow-sm"
                type="textarea"
                :rows="5"
                placeholder="..."
                v-model="model.description"
              ></el-input>
              <br />
            </div>
          </div>
        </div>
      </form>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import configTable from './status-table';
import i18n from 'src/i18n';
import InfoTable from 'src/components/Tables/InfoTable.vue';
import MixinColors from 'src/util/mixinColor';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinTranslate from 'src/util/mixinTranslate';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-create',
  mixins: [
    MixinColors,
    MixinDialog,
    MixinForm,
    MixinPermissions,
    MixinTranslate,
    MixinValidations,
  ],
  components: {
    [InfoTable.name]: InfoTable,
  },
  data() {
    return {
      disabledField: false,
      model: {
        code: null,
        name: null,
        description: null,
        color: null,
        color_text: null,
        order: null,
        module_id: [],
      },
      modules: [],
      modelValidations: {
        code: { required: true, max: 11 },
        name: { required: true, max: 255 },
        order: { required: true, min_value: 0 },
      },
    };
  },
  computed: {
    getColumns() {
      return [...configTable().tableColumns];
    },
    getInfoData() {
      return {
        ...{
          ...this.modules,
          modules: this.getModulesSelected,
        },
      };
    },
    getModulesSelected() {
      try {
        return this.modules.names.map((element) => {
          return { name: element };
        });
      } catch (error) {
        return [];
      }
    },
  },
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  methods: {
    updateDisabledField(value) {
      this.disabledField = value;
    },
    updateValueT(value) {
      this.model.color_text = value.hex;
    },

    /**
     * Método para validar un formulario de edición o guardado
     */
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit('addEdit', this.model);
        }
      });
    },
    handleClickOnCode() {
      const tableCodes = Object(
        JSON.parse(sessionStorage.getItem('tableCode'))
      );

      if (!isset(this.model.code)) {
        this.codeGenerator(i18n.t('samples.ground_types'), tableCodes);
      }
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model = {
        ...editForm,
        isEdit: true,
      };
      sessionStorage.removeItem('editForm');
    }
  },

  created() {
    if (this.isIndex()) {
      Promise.all([Axios.getMasters('modules/indexfield')])
        .then((response) => {
          const [responseModules] = response;
          this.modules = this.concatAll(responseModules.data.data);
        })
        .catch((error) => {
          this.showMessageErrors(error);
        });
    } else {
      console.log(error);
    }
  },
};
</script>
